module.exports = __webpack_public_path__ + "static/22-wikipedia-january2001-6d64a15650bbb31540b57082f0014889.jpg";